import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useTranslation } from 'react-i18next';

const GroupMessageSmsActionButtons = () => {
  const { t } = useTranslation(['common']);
  return (
    <Button
      variant='contained'
      color='primary'
      startIcon={<AddCircle />}
      component={Link as any}
      to={RoutesEnum.GroupMessageSmsCreate}
      disableElevation
    >
      {t('common:button.create')}
    </Button>
  );
};

export default GroupMessageSmsActionButtons;
